import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button as RButton, Card, CardBody, CardTitle, Form } from 'reactstrap';
import { getData } from 'core/ducks/update';
import { Table, Thead, Tbody, Tr } from 'table';
import T from 'modules/i18n';

class Applications extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      fields: [],
      layout: [],
      sort: 'created',
      sort_method: 'desc',
    }
  }

  componentDidMount() {
    this.getContent();
  }

  getContent = async () => {
    const { node } = this.props;
    const uuid = node.application;
    const { form, field, registry, registry_fields } = JSON.parse(node.options);

    const url = ['flows', 'applications-form-field']
    if (uuid && uuid !== '' && form && form !== '' && field && field !== '' && registry && registry !== '' && registry_fields && registry_fields !== '') {
      url.push(`uuid/${uuid}`);
      url.push(`form/${form}`);
      url.push(`field/${field}`);
      url.push(`registry/${registry}`);
      url.push(`registry_fields/${registry_fields}`);
    }
    const response = await this.props.dispatch(getData(url.join('/')));
    this.setState({
      data: response.values,
      fields: Object.keys(response.values[0]),
      layout: { round: { sortable: true } }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.node !== this.props.node)
      this.getContent();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.disabled)
      return;
    const { node, onSubmit } = this.props;
    const formdata = new FormData();
    formdata.append(node.mname, '');
    onSubmit(formdata);
  }

  render() {
    const { className, disabled } = this.props;
    return (
      <Card className={className}>
        <CardBody>
          <CardTitle dangerouslySetInnerHTML={{ __html: this.state.text }} />
        </CardBody>
        {(this.state.data && this.state.data !== '') &&
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col>
                <Table>
                  <Thead>
                    <Tr
                      className="text-capitalize"
                      data={[...this.state.fields]}
                      layout={this.state.layout}
                      sortBy={this.state.sort}
                      sortMethod={this.state.sort_method}
                      onClick={this.handleSortChange}
                    />
                  </Thead>
                  <Tbody refreshing={this.state.refreshing}>
                    <Tr
                      data={this.state.data}
                      layout={this.state.layout}
                      order={this.state.fields}
                      badge_colors={this.badge_colors}
                    >
                    </Tr>
                  </Tbody>
                </Table>
              </Col>
            </Row>
            <Row style={{ marginTop: 10, marginBottom: 10 }}>
              <Col className="d-flex justify-content-end">
                <RButton className='mr-5 btn btn-info' disabled={disabled}><T>continue</T></RButton>
              </Col>
            </Row>
          </Form>
        }
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({});

Applications = connect(mapStateToProps)(Applications);

export default Applications;
